import kamala from '../../kamala'
import List from './List'
import ListItem from './ListItem'

const KListFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(List.name, List)
    Vue.component(ListItem.name, ListItem)
  },
  KList: List,
  KListItem: ListItem,
}

export { List, ListItem }

export default KListFamily
